import { defineMessages } from 'react-intl'

export default defineMessages({
  'OrderSupplies.form_shipTo': {
    id: 'supplies.form_shipTo',
    defaultMessage: 'Ship To',
  },
  'OrderSupplies.form_address': {
    id: 'supplies.form_address',
    defaultMessage: 'Address',
  },
  'OrderSupplies.form_country': {
    id: 'supplies.form_country',
    defaultMessage: 'Country',
  },
  'OrderSupplies.form_city': {
    id: 'supplies.form_city',
    defaultMessage: 'City',
  },
  'OrderSupplies.form_email': {
    id: 'supplies.form_email',
    defaultMessage: 'Email',
  },
  'OrderSupplies.form_phone': {
    id: 'supplies.form_phone',
    defaultMessage: 'Phone',
  },
  'OrderSupplies.form_postal_code': {
    id: 'supplies.form_postal_code',
    defaultMessage: 'Zip Code',
  },
  'OrderSupplies.form_province': {
    id: 'supplies.form_province',
    defaultMessage: 'State',
  },

  'OrderSupplies.checkout_default': {
    id: 'supplies.checkout_default',
    defaultMessage: 'Default',
  },
  'OrderSupplies.checkout_title': {
    id: 'supplies.checkout_title',
    defaultMessage: 'Checkout',
  },
  'OrderSupplies.checkout_shipping_details': {
    id: 'supplies.checkout_shipping_details',
    defaultMessage: 'Shipping details',
  },
  'OrderSupplies.checkout_your_order': {
    id: 'supplies.checkout_your_order',
    defaultMessage: 'Your order',
  },

  'OrderSupplies.checkout_address': {
    id: 'supplies.checkout_address',
    defaultMessage: 'Address',
  },
  'OrderSupplies.checkout_city': {
    id: 'supplies.checkout_city',
    defaultMessage: 'City',
  },
  'OrderSupplies.checkout_province': {
    id: 'supplies.checkout_province',
    defaultMessage: 'State',
  },
  'OrderSupplies.checkout_postal_code': {
    id: 'supplies.checkout_postal_code',
    defaultMessage: 'Zip Code',
  },
  'OrderSupplies.checkout_country': {
    id: 'supplies.checkout_country',
    defaultMessage: 'Country',
  },
  'OrderSupplies.checkout_phone': {
    id: 'supplies.checkout_phone',
    defaultMessage: 'Phone',
  },
  'OrderSupplies.checkout_email': {
    id: 'supplies.checkout_email',
    defaultMessage: 'Email',
  },
  'OrderSupplies.checkout_preferred_contact': {
    id: 'supplies.checkout_preferred_contact',
    defaultMessage: 'Preferred contact',
  },

  'OrderSupplies.checkout_sales_tax': {
    id: 'supplies.checkout_sales_tax',
    defaultMessage: 'Sales tax',
  },
  'OrderSupplies.checkout_order_total': {
    id: 'supplies.checkout_order_total',
    defaultMessage: 'Order total',
  },
  'OrderSupplies.checkout_cancel': {
    id: 'supplies.checkout_cancel',
    defaultMessage: 'Cancel',
  },
  'OrderSupplies.checkout_done': {
    id: 'supplies.checkout_done',
    defaultMessage: 'Done',
  },
  'OrderSupplies.checkout_order_success': {
    id: 'supplies.checkout_order_success',
    defaultMessage: 'Your order have been successfully submitted!',
  },
})
